import createReactComponent from '../createReactComponent';
export default createReactComponent('omega', 'IconOmega', [
  ['path', { d: 'M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5', key: 'svg-0' }],
]);
